<template>
  <table class="t-table-v2" :class="classes">
    <slot v-if="!noHeader" name="head">
      <thead>
        <t-table-v2-row>
          <t-table-v2-head
            v-for="field in fields"
            :key="field.key"
            :field="field"
            :order-by="orderBy"
            :content-align="field.contentAlign"
            @sort="sort">
            <slot :name="`th(${field.key})`" :field="field">
              <div class="t-table-v2__head__inner">
                <span>{{ field.label }}</span>
                <t-table-v2-sortable
                  v-if="field.sortable"
                  :desc="desc(field)"
                />
              </div>
            </slot>
          </t-table-v2-head>
        </t-table-v2-row>
      </thead>
    </slot>
    <tbody>
    <slot :items="items">
      <t-table-v2-row v-for="(item, index) in items" :key="index">
        <t-table-v2-cell
          v-for="field in fields"
          :key="field.key"
          :content-align="field.contentAlign"
          :no-wrap="field.noWrap"
          :data-label="field.label">
          <t-skeleton v-if="loading" height="1.4rem"/>
          <slot v-else :name="`td(${field.key})`" :item="item" :value="getValue(item, field.key)">
            {{ item[field.key] }}
          </slot>
        </t-table-v2-cell>
      </t-table-v2-row>
    </slot>
    </tbody>
    <tfoot>
    <slot name="foot"></slot>
    </tfoot>
  </table>
</template>
<script>
import getValue from 'get-value';
import TSkeleton from '../TSkeleton';
import TTableV2Head from './TTableV2Head.vue';
import TTableV2Sortable from './TTableV2Sortable.vue';
import TTableV2Row from './TTableV2Row.vue';
import TTableV2Cell from './TTableV2Cell.vue';

export default {
  name: 't-table-v2',
  components: {
    TSkeleton, TTableV2Cell, TTableV2Head, TTableV2Sortable, TTableV2Row,
  },
  props: {
    fields: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    orderBy: {
      type: String,
      required: false,
      default: '',
    },
    card: {
      type: Boolean,
      required: false,
      default: false,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    noHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  provide() {
    return {
      $expanded: () => this.expanded,
    };
  },
  computed: {
    classes() {
      const classes = [];

      if (this.card) {
        classes.push('t-table-v2--as-card');
      }
      if (this.expanded) {
        classes.push('t-table-v2--expanded');
      }
      if (this.loading) {
        classes.push('t-table-v2--loading');
      }

      return classes;
    },
  },
  methods: {
    desc(field) {
      return this.orderBy === `-${field.key}`;
    },
    sort(key, direction) {
      this.$emit('sort', key, direction);
    },
    getValue,
  },
};
</script>
